import lazySizes from 'lazysizes'

document.addEventListener('turbolinks:load', function () {
  lazySizes.init()
})
